import { Emitter } from '@segment/analytics-generic-utils';
export class NodeEmitter extends Emitter {
}
//# sourceMappingURL=emitter.js.map